module.exports = __webpack_public_path__ + "img/715716_l.19966999.jpg";